import React, { useRef } from 'react';
import { pick, prop } from 'ramda';
import { useMountEffect } from 'js/hooks/useMountEffect';
import { languageService } from 'js/services/language.service';
import { useAppSelector, useUserSelector } from 'js/store/hooks';

import { ERRORS } from './constants';
import { getScript } from './helpers';
import { useRenderRecaptcha } from './hooks';

import style from './index.scss';

// this needs to be ReCaptcha once backbone will be removed
export const ReCaptchaBare = ({
    lang,
    onValidate,
    onError,
    operation,
    theme = 'light',
    size = 'normal',
    tabIndex = 0,
    casinoName,
    ssoPasDomain
}) => {
    const language = languageService.getLanguage(lang);
    const captchaRef = useRef();
    const renderRecaptcha = useRenderRecaptcha({
        language,
        onValidate,
        onError,
        operation,
        theme,
        size,
        tabIndex,
        captchaRef
    });

    useMountEffect((isMounted) => {
        const key = getScript(`https://${ssoPasDomain}/CaptchaPublicKey.php`, {
            cache: false,
            callbackParam: 'callback',
            queryParams: {
                casinoName
            }
        });

        const api = getScript('https://www.google.com/recaptcha/api.js', {
            callbackParam: 'onload',
            queryParams: {
                render: 'explicit',
                hl: language
            }
        });

        Promise.all([key, api])
            .then(([{ publicKey } = {}]) => {
                const { grecaptcha } = window;

                if (isMounted() && publicKey && grecaptcha) {
                    if (grecaptcha.render) {
                        renderRecaptcha(publicKey);
                    } else {
                        grecaptcha.ready(() => renderRecaptcha(publicKey));
                    }
                }
            })
            .catch(({ message: errorMessage }) => onError({
                ...ERRORS.SCRIPT_LOADING_ERROR,
                errorMessage
            }));
    }, [ssoPasDomain, casinoName]);

    return <div ref={captchaRef} className={`${style.container} cms-recaptcha`} />;
};

export const ReCaptcha = ({ ...props }) => {
    const lang = useUserSelector(prop('lang'));
    const {
        casinoName,
        ssoPasDomain
    } = useAppSelector(pick(['casinoName', 'ssoPasDomain']));

    return <ReCaptchaBare {...props} {...{
        lang,
        casinoName,
        ssoPasDomain
    }} />;
};
